import { Box } from "@mui/material";
import React from "react";

const HandleResetPassword = () => {
  return <Box>HandleResetPassword</Box>;
};

export default HandleResetPassword;
